module.exports = __webpack_public_path__ + "img/51600.7c6a430b.jpg";